import { Col, Row } from "antd";
import React from "react";
import { Accion } from "./Accion";
import { SubirEvidencia } from "./SubirEvidencia";
import { ListadoArchivos } from "./ListadoArchivos";

export const Controles = () => {
  return (
    <Row gutter={100}>
      <Col span={14}>
        <SubirEvidencia />
      </Col>
      <Col span={5}>
        <ListadoArchivos />
      </Col>
      <Col span={5}>
        <Accion />
      </Col>
    </Row>
  );
};
